import { fromJS } from 'immutable';
export const defaultAreaRangeSeriesOptions = fromJS({
  marker: {
    enabled: false
  }
});